import { ImageOff } from 'lucide-react';
import { API_BASE } from '@/lib/api';
import { useI18n } from '@/lib/i18n';

/**
 * PODGLĄD OBRAZKA TOWARU.
 *
 * ⚠️ ŹRÓDŁO Z NASZEGO API, NIE PODPISANY LINK DO MAGAZYNU. Front ma CSP `img-src 'self' data: blob:`,
 * więc obrazek spod adresu magazynu przeglądarka BLOKUJE — zmierzone na DBW: `<img>` w drzewie,
 * właściwa nazwa w `alt`, `naturalWidth` zero i wpis w konsoli o naruszeniu polityki. Adres
 * względny załatwia to bez ruszania CSP i bez dokładania obcego hosta do kontraktu z platformą.
 *
 * ⚠️ ZWYKŁY `<img>`, BEZ `fetch` I BEZ ZAPYTANIA W CACHE BIBLIOTEKI. Ciasteczko sesji jedzie
 * z żądaniem samo (ten sam origin), a `ETag` z API zdejmuje ruch przy powrotach. Pobieranie
 * przez `fetch` do bloba dokładałoby warstwę bez jednej korzyści.
 *
 * ⚠️ POKAZUJEMY GO TYLKO W OKNIE OBRAZKA, nie na liście towarów. Obrazek rzadko decyduje o czymś
 * na liście, a lista z dwudziestoma pięcioma zdjęciami to dwadzieścia pięć żądań przy każdym
 * przewinięciu. Tutaj pobiera się pojedynczo i wtedy, gdy ktoś świadomie o niego poprosił.
 */
export function ObrazekMini({
  groupId,
  nazwaPliku,
  hasImage,
  rozmiar = 96,
}: {
  groupId: string;
  nazwaPliku: string | null;
  /** Czy portal ma bajty. `false` = nie ma po co pytać API. */
  hasImage: boolean;
  rozmiar?: number;
}) {
  const { t } = useI18n();
  const bok = { width: rozmiar, height: rozmiar };

  if (nazwaPliku === null) return null;

  /**
   * ⚠️ BRAK BAJTÓW TO NIE JEST BŁĄD — to normalny stan, dopóki biblioteki nie zgrano z automatu.
   * Ramka z wyjaśnieniem mówi, że plik JEST wskazany, tylko my go jeszcze nie mamy; pusty
   * kwadrat czytałby się jak zepsuty obrazek.
   */
  if (!hasImage) {
    return (
      <span
        title={`${nazwaPliku} — ${t('obraz.brakWBibliotece')}`}
        style={bok}
        className="flex shrink-0 flex-col items-center justify-center gap-1 rounded border border-dashed border-border text-muted-foreground"
      >
        <ImageOff className={rozmiar < 64 ? 'size-4' : 'size-5'} />
        {/* ⚠️ Napis tylko w dużej ramce — w 32 px łamał się na cztery linie (27.10.2026); mówi go dymek. */}
        {rozmiar >= 64 && <span className="px-1 text-center text-[10px] leading-tight">{t('obraz.brakWBibliotece')}</span>}
      </span>
    );
  }

  return (
    <img
      src={`${API_BASE}/items/obrazki/${encodeURIComponent(nazwaPliku)}?groupId=${groupId}`}
      alt={nazwaPliku}
      title={nazwaPliku}
      loading="lazy"
      style={bok}
      className="shrink-0 rounded border border-border object-contain"
    />
  );
}
